import { Link } from '@tanstack/react-router';
import { Center, Text, VStack } from '@chakra-ui/react';

import PrimaryButton from '@/components/common/buttons/PrimaryButton';
import { Title } from '@/components/ui/title';

const Unauthorized = () => (
	<Center minH="100dvh" p={6}>
		<VStack gap={4} maxW="md" w="full">
			<Title level="page">Unauthorized</Title>
			<Text textStyle="body" color="fg.muted" textAlign="center">
				You do not have permission to access this page.
			</Text>
			<PrimaryButton asChild w="50%">
				<Link to="/dashboard">Back</Link>
			</PrimaryButton>
		</VStack>
	</Center>
);

export const Route = createFileRoute({
	component: Unauthorized,
});
